module.exports = __webpack_public_path__ + "static/media/artist_nord-z_w.7048b80d.png";